import React, { FC } from 'react'

interface WorldIconProps {
  color?: string
}

const WorldIcon: FC<WorldIconProps> = ({ color = '#fff' }) => (
  <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 0C8.3814 0 3.93019 2.84919 1.64234 7.04182C0.594813 8.96148 0 11.1633 0 13.5C0 20.9558 6.04416 27 13.5 27C15.5697 27 17.5341 26.5333 19.2905 25.6982C22.0148 24.4029 24.2352 22.2231 25.582 19.5289C26.4898 17.7128 27 15.6641 27 13.5C27 8.36361 24.131 3.8993 19.9144 1.61856C18.0051 0.585799 15.819 0 13.5 0ZM15.1866 10.814C17.6492 9.62385 19.5697 7.57296 20.2964 5.05461C22.7638 7.04275 24.3399 10.088 24.3399 13.5C24.3399 14.6422 24.1637 15.7417 23.8372 16.7736C23.1841 15.7892 22.0664 15.1404 20.7961 15.1404C18.7816 15.1404 17.1485 16.7735 17.1485 18.788C17.1485 19.2939 17.2521 19.7769 17.4391 20.2159C17.1008 20.928 16.9115 21.7245 16.9115 22.5631C16.9115 22.9697 16.956 23.3666 17.0405 23.7489C15.9321 24.1317 14.7414 24.3399 13.5 24.3399C7.51329 24.3399 2.6601 19.4867 2.6601 13.5C2.6601 12.2202 2.88135 10.994 3.28737 9.85614C3.67707 10.1367 4.08953 10.3926 4.52144 10.6218C4.41356 11.0508 4.35631 11.4994 4.35631 11.9604C4.35631 14.1664 5.65995 16.0658 7.53839 16.9335C7.62392 18.8721 9.22266 20.4175 11.1824 20.4175C13.1969 20.4175 14.8299 18.7844 14.8299 16.7699C14.8299 16.1324 14.6659 15.5329 14.3786 15.0116C14.9644 14.14 15.3071 13.0897 15.3071 11.9604C15.3071 11.5678 15.2656 11.1842 15.1866 10.814Z"
      fill={color}
    />
  </svg>
)

export default WorldIcon
